@import '../../../globals/main.scss';

pn-product-pricelist {
  pn-spinner {
    margin: 1em auto;
  }

  h2,
  .heading {
    text-align: center;
    font-size: 1.5em;
    line-height: 1.1;
    font-weight: bold;
    margin-bottom: 1rem;
  }

  .content,
  .weightselection,
  .resultlist {
    max-width: 50em;
    margin: 0 auto 1.6rem;
  }

  .weightoption {
    display: flex;
    gap: 1.6rem;
  }

  .weightoption-input {
    width: 5em;
    position: relative;
    display: none;

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  .weightoption-input-abbreviation {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 1.2em;
    margin-top: 1.55rem;
    font-weight: 500;
  }

  .weightoption-range {
    flex-grow: 1;
    align-self: flex-end;
    position: relative;
    top: 0.5em;
    input {
      width: calc(100% - 1.5em);
    }
    datalist {
      width: 100%;
      display: flex;
      justify-content: space-between;
      font-size: 0.75em;
    }
  }

  .resultlist:not([data-list-count='0']) {
    margin-top: 2em;
  }
}
